import axios from "axios";
import { useHistory } from "react-router-dom";

const User = {
    data: null,
    authorities: [],
    isLoggedIn: false,
    isLoading: true,
}; 

const InitUser = async () =>{
         await axios.get("https://innounita.univ-unita.eu/backend/user").then((response) =>{
            if(response.data){
                User.data = response.data;
                User.authorities = response.data.authorities;
                User.isLoggedIn=true;
                User.isLoading=false;
            }else{
                User.data = null;
                User.authorities = [];
                User.isLoggedIn = false;
                User.isLoading = false;
            }
        })
        .catch(() => {
            User.data = null;
            User.authorities = [];
            User.isLoggedIn = false;
            User.isLoading = false;
        })
}
InitUser();
console.log(User)
export default User;
